var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormModal',{attrs:{"model":_vm.model,"init":_vm.init,"modal-id":"inventory","beforeSaving":_vm.beforeSaving,"onSetIsEditMode":_vm.onSetIsEditMode,"hide-footer":true},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var error = ref.error;
return [_c('GridPage',{attrs:{"form-default":{
                },"filters-default":{
                    provider: 'amazon',
                    quantity: '',
                    sort: 'name',
                },"filter-items":[
                    {
                        vModel: 'quantity',
                        title: '在庫',
                        options: [
                            { text: '全て', value: '' },
                            { text: 'あり', value: '1' },
                            { text: 'なし', value: '0' } ],
                    },
                    {
                        vModel: 'sort',
                        title: '順番',
                        options: [
                            { text: '▲ 名前', value: 'name', },
                            { text: '▼ 名前', value: '-name', },
                            { text: '▲ 在庫', value: 'quantity', },
                            { text: '▼ 在庫', value: '-quantity', } ],
                    } ],"filters-q-placeholder":"Name, SKU, ASIN","form-modal-id":"item","search-action":"item/index","hide-add":true,"row-clicked":false},scopedSlots:_vm._u([{key:"form",fn:function(ref){
                var form = ref.form;
                var init = ref.init;
return [_c('Item',{attrs:{"model":form,"init":init}})]}},{key:"column",fn:function(ref){
                var item = ref.item;
return [_c('b-row',{staticClass:"no-gutters w-100"},[_c('b-col',{staticClass:"align-self-center px-3",attrs:{"md":"12"}},[_c('strong',[_vm._v(_vm._s(item.data.productName))])]),_vm._v(" "),_c('b-col',{staticClass:"align-self-center px-3",attrs:{"xs":"6"}},[_c('span',[_vm._v("ASIN:"+_vm._s(item.data.asin))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("SKU:"+_vm._s(item.data.sellerSku))])]),_vm._v(" "),_c('b-col',{staticClass:"align-self-center px-3 text-right",attrs:{"xs":"6"}},[_c('b-form-checkbox',{attrs:{"switch":""},on:{"change":function($event){return _vm.toggleSyncedSwitch(item)}},model:{value:(item.synced),callback:function ($$v) {_vm.$set(item, "synced", $$v)},expression:"item.synced"}}),_vm._v(" "),_c('span',[_vm._v("x"+_vm._s(item.quantity))])],1)],1)]}}],null,true)})]}}])},[[_c('div',{key:_vm.key,staticClass:"d-flex"},[_c('ItemBadges',{staticClass:"mb-1",attrs:{"model":_vm.model}})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }